// Referentially stable fallbacks for selectors. react-redux 8's
// useSyncExternalStore requires a selector to return the same reference for
// the same input; a fresh `{}`/`[]` fallback on every call breaks that and
// either warns ("returned a different result") or infinite-loops re-renders.
export const EMPTY_OBJECT = Object.freeze({})
export const EMPTY_ARRAY = Object.freeze([])
